import type React from "react";
import NotebookLayoutContainer from "@/features/notebook/containers/NotebookLayoutContainer";

const NotebookLayoutPage: React.FC = () => {
	return <NotebookLayoutContainer />;
};

export default NotebookLayoutPage;
